import { render, staticRenderFns } from "./WindowsResizeIcon.vue?vue&type=template&id=2840929a&"
import script from "./WindowsResizeIcon.vue?vue&type=script&lang=js&"
export * from "./WindowsResizeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports